import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NotifyUsersBy } from '../../constants/KRollConstants';
import { KRollService } from '../../services/api-services/kroll.service';
import { ShippingService } from '../../services/api-services/shipping.service';
import { FormService } from '../../services/form.service';
import { HelperService } from '../../services/helper.service';
import { arrayMinLengthByKey } from '../../validator/form-validators.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';
import { Validators, AbstractControl } from '@angular/forms';
import { PreAssessmentService } from 'src/app/core/services/api-services/pre-assessments.service';
import { AddReasonPopupMultiLng } from '../add-reason-popup-multi-lng/add-reason-popup-multi-lng.component';
import { UserService } from '../../services/api-services/user.service';

enum NotifyType {
  sms = 'sms',
  message = 'message',
  do_not = 'do_not',
}

@Component({
  selector: 'app-health-care-plan-status',
  templateUrl: './health-care-plan-status.component.html',
  styleUrls: ['./health-care-plan-status.component.scss'],
})
export class HealthCarePlanStatusComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  NotifyType = NotifyType;
  tenant: any = localStorage.getItem('tenant');
  payload: { NotifyUsers: boolean; NotifyUsersBy: Array<number> } = {
    NotifyUsers: true,
    NotifyUsersBy: [],
  };
  preSelectedStatuses = [4, 6];
  rejectedReason: any[] = [];
  rejectedReasonRequired: boolean = true;
  selectedStatus: any;
  isDiseaseId: any;
  disease: any;
  selectedLanguage: any = 'en';
  constructor(
    public dialogRef: MatDialogRef<HealthCarePlanStatusComponent>,
    public dialog: MatDialog,
    private fb: FormBuilder,
    public toast: ToastrService,
    public shippingService: ShippingService,
    public formService: FormService,
    public krollService: KRollService,
    public userService: UserService,
    public preAssessmentService: PreAssessmentService,
    public validationMessagesService: ValidationMessagesService,
    public helperService: HelperService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any
  ) {

  }

  ngOnInit(): void {
    this.selectedStatus = this.props.item.status;
    this.isDiseaseId = this.props.item.disease_id;
    this.initializeForm();
    this.getRejectedReason();
  }
  onLanguageChange(event: any) {
    this.selectedLanguage = event.value;
  }
  onCheckChange(event: MatCheckboxChange) {
    const customMessageControl = this.form.get('custom_message');
    if (customMessageControl) {
      if (event.checked) {
        this.addNotifyControl();
      } else {
        // Set custom_message control value to false
        customMessageControl.setValue(false);
        this.form.removeControl('NotifyUsersBy');
      }
    }
  }
  onCheckMessage(event: MatCheckboxChange) {

    const validators = this.getConditionalValidators(); // Get the updated validators
    this.form.controls['message'].setValidators(validators); // Set the validators for the 'message' control
    this.form.controls['message'].updateValueAndValidity(); // Update the value and validity of the control
  }

  initializeForm() {
    let { NotifyUsers } = this.payload;

    /* const isCustomMessageSelected = this.preSelectedStatuses.includes(
      this.props.item.status
    ); */
    const isCustomMessageSelected = false;

    const rejectedReasonValidators = (this.preSelectedStatuses.includes(this.selectedStatus)) ? [Validators.required] : [Validators.nullValidator];

    this.form = this.fb.group({
      NotifyUsers: new FormControl(NotifyUsers),
      custom_message: new FormControl(isCustomMessageSelected),
      selectedLanguage: new FormControl(this.selectedLanguage),
      RejectedReasonID: new FormControl("", rejectedReasonValidators),
      message: new FormControl('', this.getConditionalValidators()),
    });
    this.disease = this.props.item.disease;
    this.addNotifyControl();
  }

  isCustomMessageVisible(): boolean {
    return this.preSelectedStatuses.includes(this.props.item.status);
  }

  getConditionalValidators() {
    return (control: AbstractControl) => {
      if (this.form.get('custom_message')?.value && this.form.get('NotifyUsers')?.value) {
        return Validators.required(control);
      } else {
        return null; // If custom_message is unchecked, disable the validation.
      }
    };
  }

  get notifyByArray() {
    return this.form.get('NotifyUsersBy') as FormArray;
  }
  private addNotifyControl() {
    this.form.addControl(
      'NotifyUsersBy',
      this.fb.array([], arrayMinLengthByKey(1, 'isChecked'))
    );
    NotifyUsersBy.forEach((x: any) => {
      this.notifyByArray.push(
        this.fb.group({
          id: new FormControl(x.id),
          value: new FormControl(x.value),
          isChecked: new FormControl(x.isChecked),
          disable: new FormControl(this.tenant == 'sl' ? true : false),
        })
      );
    });
  }

  formSubmit() {
    if (this.form.valid) {
      this.isLoading = true;
      let payload: {
        id: any;
        selectedLanguage: any;
        RejectedReasonID: any;
        user_id: string;
        status: string;
        CustomMessage: boolean;
        Message?: string;
        NotifyUsers: boolean;
        NotifyUsersBy: any[];
      } = {
        id: this.props.item.id,
        selectedLanguage: this.selectedLanguage,
        RejectedReasonID: this.form.value.RejectedReasonID,
        user_id: this.props.item.user_id,
        status: this.props.item.status,
        CustomMessage: this.form.value.custom_message,
        Message: this.form.value.custom_message ? this.form.value.message : '',
        NotifyUsers: this.form.value.NotifyUsers,
        NotifyUsersBy: this.form.value.NotifyUsersBy?.length > 0 ? this.form.value.NotifyUsersBy.filter((f: any) => f.isChecked).map((m: any) => m.id) : [],
      };
      // additional logic for status 11 or 12
      if (this.props.item.status == 11 || this.props.item.status == 12 || this.isDiseaseId == 5) {
        payload.NotifyUsers = false;
        payload.NotifyUsersBy = [];
      }
      // API call to update delivery status
      this.preAssessmentService.changeStatus(payload).subscribe(
        (res) => {
          if (res.body.success) {
            // Display success message
            this.toast.success(res.body.message);
            this.isLoading = false;
            this.dialogRef.close({ payload: payload, response: res.body });
          } else {
            // Display error message
            this.toast.error(res.body.message);
            this.isLoading = false;
          }
        },
        (err) => {
          // Display error message for API error
          this.isLoading = false;
          this.toast.error('An error occurred while updating delivery status.');
        }
      );
    } else {
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }
  coloseDilog() {
    this.dialogRef.close(false);
  }
  openAddRasonDialog() {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = '600px';
    }
    dialogRef = this.dialog.open(AddReasonPopupMultiLng, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (res.response.success) {
        this.getRejectedReason();
        this.form.controls.RejectedReasonID.setValue(res.response.data.id);
      }
    })
  }
  getRejectedReason() {
    let payload = {
      'selectedLanguage': this.selectedLanguage
    }
    this.preAssessmentService.get_cancel_reason(payload).subscribe(res => {
      if (res?.body?.success) {
        this.rejectedReason = res?.body?.data;
      }
      else {
        this.rejectedReason = [];
      }
    })
  }
}
